export default __webpack_public_path__ + "static/media/Snd_Try8.14109851.mp3";